export default __webpack_public_path__ + "static/media/eye.1c240813.svg";